import api from './api';

// Envoyer un message (DTO fields only)
export const sendMessage = async (messageDto) => {
  const response = await api.post('/messages', messageDto);
  return response.data;
};

export const sendMessageWithImage = async (messageDto, imageFile) => {
  if (!imageFile) return sendMessage(messageDto);
  
  const formData = new FormData();
  formData.append('message', JSON.stringify(messageDto));
  formData.append('image', imageFile);
  
  const response = await api.post('/messages/with-image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Récupérer la conversation entre deux utilisateurs (DTO fields only)
export const getConversation = async (senderId, receiverId) => {
  const response = await api.get('/messages/conversation', {
    params: { senderId, receiverId }
  });
  return response.data;
};

// Marquer un message comme lu
export const markAsRead = async (id) => {
  await api.patch(`/messages/${id}/read`);
};

// Récupérer les messages non lus pour un utilisateur
export const getUnreadMessages = async (receiverId) => {
  const response = await api.get(`/messages/unread/${receiverId}`);
  return response.data;
}; 

// Transporteur: fetch pending offers (used as notifications)
export const getPendingOffers = async () => {
  const response = await api.get('/transporteur/offers');
  return response.data;
};

export const acceptOffer = async (offerId) => {
  await api.post(`/transporteur/offers/${offerId}/accept`);
};

export const declineOffer = async (offerId) => {
  await api.post(`/transporteur/offers/${offerId}/decline`);
};

export const getOffer = async (offerId) => {
  const response = await api.get(`/transporteur/offers/${offerId}`);
  return response.data;
};

export const saveOffer = async (offerId) => {
  await api.post(`/transporteur/offers/${offerId}/save`);
};

export const getSavedOffers = async () => {
  const response = await api.get('/transporteur/offers/saved');
  return response.data;
};

export const unsaveOffer = async (offerId) => {
  await api.delete(`/transporteur/offers/${offerId}/unsave`);
};